import { hashHistory } from 'react-router'

export default hashHistory;



/** WEBPACK FOOTER **
 ** ./src/app/router/history.js
 **/